import { createApp } from "vue";
import { ElLoading } from "element-plus";
import App from "./App.vue";
import router from "@/router/index.ts";
import errorHandler from "@/errorHandler.js";
import pinia from "./store";
import microApp from "@micro-zoe/micro-app";
import { initMicroAppTitleManager } from "@/utils/microAppTitleManager.js";
import "./permission";
import "./global.scss";

initMicroAppTitleManager({ router, defaultTitle: "智慧能源" });

microApp.start({
  // "disable-memory-router": true,
  tagName: "micro-app",
  // lifeCycles: {
  //   created(e, appName) {
  //     console.log(`子应用${appName}被创建`);
  //   },
  //   beforemount(e, appName) {
  //     console.log(`子应用${appName}即将渲染`);
  //   },
  //   mounted(e, appName) {
  //     console.log(`子应用${appName}已经渲染完成`);
  //   },
  //   unmount(e, appName) {
  //     console.log(`子应用${appName}已经卸载`);
  //   },
  //   error(e, appName) {
  //     console.log(`子应用${appName}加载出错`);
  //   },
  // },
});

microApp.router.setBaseAppRouter(router);
microApp.router.attachAllToURL({});

const app = createApp(App);
app.use(router);
app.use(pinia);
app.use(errorHandler);
app.directive("loading", ElLoading.directive);
app.mount("#app");
